const $ = jQuery;

const AboutBook = {
  init: function () {
    const titleEl = document.querySelectorAll(
      ".product-specification--title .more-info-book"
    );

    const content = document.querySelectorAll(
      ".product-specification--content > div"
    );

    if (titleEl)
      titleEl.forEach((el, i) => {
        el.addEventListener("click", function () {
          openContent(i);
          titleEl.forEach((element) => {
            element.classList.remove("active");
          });

          el.classList.add("active");
        });
      });

    function openContent(index = 1) {
      content.forEach((el, i) => {
        if (index === i) {
          el.classList.add("active");
        } else {
          el.classList.remove("active");
        }
      });
    }
  },
};

export default AboutBook;
